import { useMutation } from '@tanstack/react-query';
import { usePermissionsRepository } from '@Hooks/useRepository';
import { UsersRepository } from '@Repositories/Permissions';

export const useActivateUser = () => {
    const users = usePermissionsRepository(UsersRepository);

    return useMutation({
        mutationFn: (userId: string) => users.activateUser(userId),
    });
};
